export const ENTITY_STATUS = {
  ACTIVE: "ACTIVE",
  PRE_INCORPORATED: "PRE_INCORPORATED",
  DISSOLVED: "DISSOLVED",
} as const;

export type EntityStatus = (typeof ENTITY_STATUS)[keyof typeof ENTITY_STATUS];

export type OverviewState = {
  id: string;
  name: string;
  isHome: boolean;
};

export type OverviewEntity = {
  id: string;
  name: string;
  entityTypeLabel: string;
  countryCode: string;
  countryName: string;
  homeStateName: string;
  status: EntityStatus;
  dateOfIncorporation: string;
  ein: string;
  states: OverviewState[];
  missingDetails: string[];
  parentId: string | null;
};

export type OverviewTreeNode = {
  entity: OverviewEntity;
  children: OverviewTreeNode[];
};

export type CompanyOverview = {
  name: string;
  website: string;
  countryName: string;
  hasSiblings: boolean;
  operatingCountries: { code: string; name: string }[];
};

export const SOURCE_FIELD = {
  DATE_OF_INCORPORATION: "dateOfIncorporation",
  ENTITY_TYPE: "entityType",
  EIN: "ein",
  SHARES: "shares",
} as const;

export type SourceField = (typeof SOURCE_FIELD)[keyof typeof SOURCE_FIELD];

/** Panel flip direction: forward when drilling into an entity, reverse when returning. */
export type FlipDirection = "forward" | "reverse";
